import { useState } from 'react'

import { Box, FormField, Text } from '@domain-group/suit-theme'

import type { CustomShortCodeModel } from '@domain-group/realhub-backend-api-types'
import type { CanvaAutofillField } from '@hooks/useCanvaAutofillFields'

type MappingCallbacks = {
  createCustomShortcode: (params: Partial<CustomShortCodeModel>) => Promise<{ success: boolean }>,
  deleteCustomShortcode: (customShortcode: CustomShortCodeModel) => Promise<{ success: boolean }>,
  updateCustomShortcode: (
    customShortcode: CustomShortCodeModel,
    params: Partial<CustomShortCodeModel>,
  ) => Promise<{ success: boolean }>,
}

type FieldMappingRowProps = {
  brandId: number,
  callbacks: MappingCallbacks,
  customShortcode?: CustomShortCodeModel,
  field: CanvaAutofillField,
}

const FieldMappingRow = (props: FieldMappingRowProps) => {
  const {
    brandId, callbacks, customShortcode, field,
  } = props
  const { createCustomShortcode, deleteCustomShortcode, updateCustomShortcode } = callbacks

  const [value, setValue] = useState(customShortcode?.value || '')
  const [saving, setSaving] = useState(false)

  const persistedValue = customShortcode?.value || ''

  const handleSave = async () => {
    const trimmedValue = value.trim()

    if (trimmedValue === persistedValue) return

    setSaving(true)

    if (customShortcode && !trimmedValue){
      await deleteCustomShortcode(customShortcode)
    } else if (customShortcode){
      await updateCustomShortcode(customShortcode, { value: trimmedValue })
    } else if (trimmedValue){
      await createCustomShortcode({
        key: field.key,
        owner_id: brandId,
        owner_type: 'Brand',
        title: field.label,
        value: trimmedValue,
      })
    }

    setSaving(false)
  }

  return (
    <Box alignItems="center" borderBottom="1px solid" borderColor="lineColor" paddingY="medium">
      <Box width="40%">
        <Text fontSize="small">{field.label}</Text>
      </Box>

      <Box width="30%">
        <Text color="bodyFontLightColor" fontSize="xsmall">{field.key}</Text>
      </Box>

      <Box width="30%">
        <FormField>
          <input
            aria-label={`${field.label} shortcode`}
            disabled={saving}
            onBlur={handleSave}
            onChange={e => setValue(e.target.value)}
            placeholder="Default"
            type="text"
            value={value}
          />
        </FormField>
      </Box>
    </Box>
  )
}

export default FieldMappingRow
